import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { DateField } from '@components/Fields/DateField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { IFilter } from '@hooks/useFilter';
import { IModalWindow } from '@hooks/useModalWindow';
import { IVendedorMovimentacaoFilter } from '@services/VendedorMovimentacaoService';
import React from 'react';

export type VendedorInventarioFilterProps = {
    filter: IFilter<IVendedorMovimentacaoFilter>
    isLoading: boolean
    atribuirModal: IModalWindow
}

export function VendedorMovimentacaoFilter ({ filter, isLoading, atribuirModal }: VendedorInventarioFilterProps) {
    const { fields } = filter;

    return (
        <FilterBar>
            <GridItem>
                <PrimaryButton onClick={atribuirModal.open}>Nova Atribuição</PrimaryButton>
            </GridItem>

            <GridItem floatRight xs={1}>
                <DateField
                    field={fields.ano}
                    disabled={isLoading}
                    views={["year"]}
                    format="yyyy"
                    updateFieldStateOnChange
                    onValueChanged={filter.handleFilterRequest}
                />
            </GridItem>
        </FilterBar>
    )
}